var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTick(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 10,
    viewBox: "0 0 14 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.7433 0.874656C12.3882 0.500306 11.7964 0.483819 11.4214 0.839744L5.45205 6.50089L2.60484 3.57759C2.24423 3.20761 1.65297 3.1995 1.28267 3.56015C0.912694 3.92045 0.904901 4.51233 1.2652 4.88231L4.75606 8.46638C4.939 8.65432 5.18213 8.74906 5.42588 8.74906C5.65716 8.74906 5.88844 8.66365 6.06953 8.49256L12.7084 2.19655C13.083 1.84121 13.0989 1.24932 12.7433 0.874656Z",
    fill: "#345088",
    stroke: "#345088",
    strokeWidth: 0.6
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTick);
export default __webpack_public_path__ + "static/media/tick.92d0df1b9e8e1c4a3c7e67ebf8071c14.svg";
export { ForwardRef as ReactComponent };